import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { QBox } from "@qualio/ui-components";
import { DesignElement } from "@design-controls/types";
import { toCompareHtml } from "../diff/toCompareHtml";
import { renderCompareDiff } from "../diff/renderCompareDiff";
import {
  STRIKETHROUGH_CLASS,
  compareDiffStyles,
} from "../diff/compareDiffStyles";

type Props = {
  older: DesignElement;
  viewed: DesignElement;
  strikethrough?: boolean;
};

export const CompareDiff: React.FC<Props> = ({
  older,
  viewed,
  strikethrough = false,
}) => {
  const { t } = useTranslation();

  // Strikethrough only swaps a class, so toggling it never re-runs the diff.
  const html = useMemo(
    () => renderCompareDiff(toCompareHtml(older, viewed, t)),
    [older, viewed, t],
  );

  // A4 page on a gray canvas, as in document-editor's DocumentLayout.
  return (
    <QBox
      bg="gray.50"
      border="1px"
      borderColor="gray.200"
      borderRadius="4px"
      display="flex"
      justifyContent="center"
      px={4}
      py={4}
    >
      <QBox
        bg="white"
        border="1px"
        borderColor="gray.200"
        boxShadow="md"
        width="210mm"
        maxWidth="100%"
        minHeight="297mm"
        padding="20mm"
        className={strikethrough ? STRIKETHROUGH_CLASS : undefined}
        sx={compareDiffStyles}
        data-cy="compare-diff"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </QBox>
  );
};
